export default __webpack_public_path__ + "static/media/contact.26580c03.svg";